module.exports = __webpack_public_path__ + "static/media/Icon_Ticket.0c03a462.png";